<template>
  <div class="emissionSourceNew" ref="emissionSourceNew">
    <div class="emission_bg"></div>
    <div class="emission_box">
      <div class="allCount boldNumber">{{ listData.count }}</div>
      <div class="emission_text">排放源总数</div>
      <div class="emission_title-text">
        <div class="text1">类型</div>
        <div class="text2">数量</div>
        <div class="text3">工作中</div>
      </div>
      <ul class="bar_box">
        <li class="everyli" v-for="(item, i) in listData.typeCount" :key="i">
          <div v-if="item.name && item.count">
            <span class="listName">{{ item.name }}</span>
            <span class="listCount number count">{{ item.count }}</span>
            <span class="listCount number onlineCount">{{ item.onLine }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
export default {
  props: ["matrix", "x", "y"],
  data() {
    return {
      pageInfo: 'emissionSourceNew.vue',
      computedName: '排放源清单管理组件',
      customerId: this.$store.state.customerId,
      listData: { count: 0, type: [], typeCount: [] },
      setTime1: null,
    };
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.emissionSourceNew).outerWidth();
    let h = $(that.$refs.emissionSourceNew).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
  },
  methods: {
    async getListData() {
      if (this.setTime1) {
        clearTimeout(this.setTime1);
      }
      let findInventoryOnline = CONFIG.requestName + this.$apiOpt.findInventoryOnline;
      let res = await this.$apiUtils.get(findInventoryOnline, {
        customerId: this.customerId,
      });
      this.listData = res;
      this.setTime1 = setTimeout(() => {
        this.getListData();
      }, 60 * 1000 * 5);
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.emissionSourceNew {
  height: 250px;
  width: 600px;
  cursor: pointer;
  .emission_bg {
    position: absolute;
    bottom: 20px;
    @include bg-box(560px, 180px, "emissionBg.png");
    pointer-events: none;
  }
  .emission_box {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-top: 30px;
    height: 178px;
    .allCount {
      font-size: 38px;
      font-weight: 400;
      color: #c1fdff;
      line-height: 162px;
      z-index: 2;
      text-align: center;
      width: 178px;
    }
    .emission_text {
      position: absolute;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 12px;
      bottom: 78px;
      left: 80px;
    }
    .emission_title-text {
      right: 20px;
      width: 382px;
      height: 44px;
      position: absolute;
      display: flex;
      justify-content: space-between;
      .text1 {
        width: 190px;
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        line-height: 44px;
        margin-left: 10px;
      }
      .text2,
      .text3 {
        @extend .text1;
        width: 91px;
      }
    }
    .bar_box {
      width: calc(100% - 178px);
      display: flex;
      flex-wrap: wrap;
      padding-top: 44px;
      align-content: space-around;
      justify-content: space-around;
      z-index: 1;
      .everyli {
        @include bg-box(372px, 28px, "li_bg.png");
        div {
          text-align: left;
          align-items: center;
          display: flex;
          justify-content: space-between;
          height: 100%;
          .listName {
            display: inline-block;
            width: 205px;
            z-index: 2;
            height: 16px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(224, 224, 224, 1);
            line-height: 16px;
            white-space: nowrap;
            margin-left: 5px;
          }
          .count {
            width: 91px;
            display: inline-block;
            font-size: 22px;
            color: #fffcc7;
            line-height: 22px;
            margin-left: 10px;
          }
          .onlineCount {
            @extend .count;
            color: #31ffae;
          }
        }
      }
    }
  }
}
</style>
